import { render, staticRenderFns } from "./InterpretationValidateTable.vue?vue&type=template&id=5935be2e&"
import script from "./InterpretationValidateTable.vue?vue&type=script&lang=js&"
export * from "./InterpretationValidateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports